module.exports = __webpack_public_path__ + "img/49.09f770fc.jpg";